import Vue from 'vue'
import { PopupManager } from 'element-ui/src/utils/popup'
import UmBusUser from './index.vue'
const SelectUserConstructor = Vue.extend(UmBusUser) // 直接将Vue组件作为Vue.extend的参数
let instance
const instances = []
let seed = 1

const SelectUser = (options) => {
  options = options || {}
  const id = 'export_' + seed++
  console.log(options)
  instance = new SelectUserConstructor({
    data: {
      callback: options.callback || null
    },
    propsData: {
      organType: options.organType || [1, 2, 3, 4],
      organNature: options.organNature || [0, 1],
      limit: options.limit || (options.limit === 0 ? 0 : 1),
      value: options.value || [],
      projectId: options.projectId || null,
      buildingId: options.buildingId || null,
      contractId: options.contractId || null,
      placeholder: options.placeholder || '请选择'
    }
  }) // 实例化
  instance.id = id
  instance.isApi = true
  instance.$mount()
  instance.showModal() // 显示弹框
  document.body.appendChild(instance.$el)
  // instance.visible = true
  instance.$el.style.zIndex = PopupManager.nextZIndex()
  instances.push(instance)
  // 如果传入ID 就直接开始下载
  if (options.operateProgressId) {
    instance.startProgress()
  }
  return instance
}
SelectUser.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].$destroy(true)
  }
}

export default {
  install: Vue => {
    Vue.component('um-bus-user', UmBusUser)
    Vue.prototype.$selectUser = SelectUser // 将组件暴露出去，并挂载在Vue的prototype上
  }
}
